import type { PropsWithChildren } from 'react';
import Heading from '@/components/shared/Heading';
import Image from '@/components/shared/Image';
import Text from '@/components/shared/Text';

interface CarrouselItemProps extends PropsWithChildren {
  img?: {
    src?: string;
    alt?: string;
  };
  title?: string;
  description?: string;
  actions: React.ReactNode;
}
export const CarrouselItem = ({
  img,
  title,
  description,
  actions,
  children
}: CarrouselItemProps) => {
  return (
    <div className="grid grid-cols-1 justify-center gap-6 lg:grid-cols-[20rem,_28rem] lg:gap-20 2xl:grid-cols-[25rem,_28rem]">
      {img?.src && (
        <Image
          src={img.src}
          alt={img.alt || title || 'Imagem'}
          height={140}
          width={180}
          className="m-auto h-[8.75rem] w-auto lg:h-auto lg:max-h-80 lg:w-80 2xl:max-h-[25rem] 2xl:w-[25rem]"
        />
      )}
      <div className="flex flex-col items-center gap-4 lg:flex-auto lg:shrink-0 lg:grow lg:items-start">
        <Heading display variant="h6" className="text-blue-500 2xl:text-[2rem] 2xl:leading-10">
          {title}
        </Heading>
        <Text className="text-grey-800">{description}</Text>
        {actions}
        {children}
      </div>
    </div>
  );
};
